import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig'
import { authHeader } from '../_helpers/auth-header'

export const vaccineVaccinationsService = {
  update,
  getAll,
  getDetails,
};
function getAll(params = {}) {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/vaccination?${queryString.stringify(params)}`,
  }).then(response => response.data);
}

function getDetails(id) {
  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/vaccination/${id}`,
  }).then(response => response.data);
}

function update(id, data) {
  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/vaccination/${id}`,
    data: data
  }).then(response => response.data.data);
}